import $ from "jquery";
import { reloadScriptGallery } from "../components/gallery";
import { smoothscroll } from "../utils/smoothscroll";

const $document = $(document);

$document.on("click", ".post-card__comment-trigger", function () {
  const $trigger = $(this);
  const $comments = $trigger
    .closest(".post-card")
    .find(".post-card__comments[data-level='1']");

  toggleComments($trigger, $comments);
});
$document.on("click", ".post-card__reply-button--show", function () {
  const $trigger = $(this);
  const $hideTrigger = $trigger
    .parent()
    .children(".post-card__reply-button--hide");
  const $comments = $trigger
    .closest(".post-card__comment")
    .find(".post-card__comments");

  toggleComments($trigger, $comments, $comments.data("level"));
  $trigger.hide();
  $hideTrigger.show();
});
$document.on("click", ".post-card__reply-button--hide", function () {
  const $trigger = $(this);
  const $showTrigger = $trigger
    .parent()
    .children(".post-card__reply-button--show");
  const $comments = $trigger
    .closest(".post-card__comment")
    .find(".post-card__comments");

  toggleComments($trigger, $comments);
  $trigger.hide();
  $showTrigger.show();
});
$document.on("click", ".post-card__comment-actions-reply", function () {
  const $trigger = $(this);
  const $showTrigger = $trigger
    .closest(".post-card__comment")
    .find(".post-card__reply-button--show");
  const $hideTrigger = $trigger
    .closest(".post-card__comment")
    .find(".post-card__reply-button--hide");

  if ($showTrigger.length) {
    $showTrigger.trigger("click");
  } else {
    const $comments = $trigger
      .closest(".post-card__comment")
      .find(".post-card__comments");

    toggleComments($trigger, $comments, $comments.data("level"));
    $hideTrigger.show();
  }
});

const toggleComments = ($trigger, $comments, level = 1) => {
  if ($comments.is(":hidden")) {
    $comments.slideDown(
      {
        start: function () {
          $comments.css({
            display: "flex",
          });
        },
        done: function () {
          if ($trigger.hasClass("with-focus")) {
            $comments
              .find(`.post-card__input[data-level="${level}"]`)
              .trigger("focus");
          }
        },
      },
      300
    );
  } else {
    if (level === 1) {
      $comments.slideUp(300);
    } else {
      if ($trigger.hasClass("with-focus")) {
        $comments
          .find(`.post-card__input[data-level="${level}"]`)
          .trigger("focus");
      }
    }
  }
};

/* ------------------------------------------------------ */

$(() => {
  const queryString = window.location.search;

  if (new RegExp("postId=[0-9]+").test(queryString)) {
    smoothscroll(".post-card", "header");
  }

  if (new RegExp("editPost=[0-9]+").test(queryString)) {
    smoothscroll(".company__header--margin", "header");
  }
});

/* ------------------------------------------------------ */

const relocateGallery = ($postCard) => {
  const $gallery = $postCard.children(".post-card__top").find(".gallery");

  if ($gallery.length !== 0) {
    $postCard
      .children(".post-card__gallery-wrapper")
      .html($gallery.get(0).outerHTML);
    $gallery.remove();
  }
};

export const reloadScriptPostCard = () => {
  const $postCard = $(".post-card");

  $postCard.each(function (index) {
    relocateGallery($(this));

    if (index === $postCard.length - 1) {
      reloadScriptGallery();
    }
  });
};
reloadScriptPostCard();
